(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-mybets-wager/assets/jotai/mybets-atoms.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-mybets-wager/assets/jotai/mybets-atoms.js');
"use strict";

var _svs$lyckoplatsen$dat, _svs$lyckoplatsen$dat2, _svs$lyckoplatsen$dat3;

const {
  atom
} = jotai;
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
const data = svs.lyckoplatsen.data.mybets_wagers;
const wagerId = svs.lyckoplatsen.data.shared_mybets_wager.wagerId;
const {
  prolongableWagers,
  unProlongedWagers
} = ((_svs$lyckoplatsen$dat = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.prolongable_wagers) || {};
const initialResult = (_svs$lyckoplatsen$dat2 = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat2 === void 0 ? void 0 : _svs$lyckoplatsen$dat2.result;
const currentWager = (_svs$lyckoplatsen$dat3 = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat3 === void 0 || (_svs$lyckoplatsen$dat3 = _svs$lyckoplatsen$dat3.mybets_wagers) === null || _svs$lyckoplatsen$dat3 === void 0 || (_svs$lyckoplatsen$dat3 = _svs$lyckoplatsen$dat3.wagers) === null || _svs$lyckoplatsen$dat3 === void 0 ? void 0 : _svs$lyckoplatsen$dat3[0];
let isExamined = false;
if (currentWager) {
  var _currentWager$examine;
  isExamined = (_currentWager$examine = currentWager.examinedDraws) === null || _currentWager$examine === void 0 ? void 0 : _currentWager$examine.some(d => initialResult && d.drawNumber === initialResult.drawNumber && productMapping.getProductNumericId(d.productId) === initialResult.productId);
}
const atoms = {
  currentWagerIdAtom: atom(wagerId),
  wagersAtom: atom(data === null || data === void 0 ? void 0 : data.wagers),
  isExaminedAtom: atom(isExamined),
  wagerToProlongAtom: atom(),
  prolongableWagersAtom: atom(prolongableWagers),
  unProlongedWagersAtom: atom(unProlongedWagers)
};
setGlobal('svs.lyckoplatsen.shared_mybets_wager.jotai', {
  atoms
});

 })(window);